import clsx from "clsx";
import React, { FC } from "react";

import { Icon } from "../../icon";
import { PaginationNumbersItem } from "./pagination-numbers-item";

export interface PaginationDotsProps {
  currentPageIndex: number;
  totalPages: number;
  setCurrentPageIndex: (pageIndex: number) => void;
  isOpen: boolean;
  openFn: () => void;
  closeFn: () => void;
}

export const PaginationDots: FC<PaginationDotsProps> = ({
  totalPages,
  currentPageIndex,
  setCurrentPageIndex,
  isOpen,
  openFn,
  closeFn,
}) => {
  return (
    <PaginationNumbersItem isActive={false}>
      <div className="relative">
        <div onClick={openFn} className="py-1 px-2 cursor-pointer">
          ...
        </div>
        <div
          className={clsx(
            "absolute left-0 flex rounded overflow-hidden shadow",
            "z-20 fixed outline outline-2 outline-primary mt-[2px]",
            !isOpen && "invisible"
          )}
        >
          <div
            className={clsx(
              "bg-light z-20 flex flex-col flex-grow",
              "max-h-48 primary-scrollbar overflow-y-auto"
            )}
          >
            {new Array(totalPages).fill(null).map((_, i) => {
              return (
                <button
                  key={i}
                  type="button"
                  className="py-1 px-2 flex items-center gap-1"
                  onClick={() => {
                    setCurrentPageIndex(i);
                    closeFn();
                  }}
                >
                  {i + 1}
                  {i === currentPageIndex && <Icon icon="check" className="text-primary w-4" />}
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </PaginationNumbersItem>
  );
};
